export default function Terms() {
  return (
    <div data-testid="terms-page" className="pt-32 pb-24 container mx-auto px-4 max-w-3xl">
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mb-6">Terms & Conditions</h1>
      <div className="prose prose-zinc max-w-none">
        <p>By using CFT Creations services, bookings, or rentals, you agree to these terms.</p>
        <h3>Studio Bookings</h3>
        <ul>
          <li>Bookings are confirmed only after payment.</li>
          <li>Reschedule allowed up to 24h before; cancellations within 24h forfeit 50%.</li>
        </ul>
        <h3>Props Rental</h3>
        <ul>
          <li>Refundable security deposit per item.</li>
          <li>Late returns incur ₹100/day/item.</li>
          <li>Damaged items will be deducted from deposit.</li>
        </ul>
        <h3>Services</h3>
        <p>Project scope, timeline, and pricing are agreed in a separate engagement letter.</p>
        <p>For any questions email <a href="mailto:info@cftcreations.com">info@cftcreations.com</a>.</p>
      </div>
    </div>
  );
}
